import React from "react";
import ForgotPageSection from "../sections/ForgotPageSection/Content";
const ForgotPage = () => {
  return <ForgotPageSection />;
};

export default ForgotPage;
